module.exports = __webpack_public_path__ + "img/h22.ddda505a.jpg";